import { api } from '@/services'
const qs = require('qs')

export const list = (params) => {
  return api.get('/web/qaAppointmentDashboard/list', {
    params: params,
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    },
  })
}

export const countApppointmentByStatus = (params) => {
  return api.get('/web/qaAppointmentDashboard/countApppointmentByStatus', {
    params: params,
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    },
  })
}

export const generateAppointmentDashboardReport = (params) => {
  return api.get('/web/qaAppointmentDashboard/createReport', {
    params: params,
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    },
    responseType: 'arraybuffer'})
}
